import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import Popup from '@jetbrains/ring-ui/components/popup/popup'

import type {BuildTypeId} from '../../../../../types'
import BuildTypePauseInfo from '../../../BuildTypePauseInfo/BuildTypePauseInfo'
import IconButton from '../../../IconButton/IconButton'
import SvgIcon from '../../../SvgIcon/SvgIcon'

import styles from './BuildTypePauseDropdown.css'

type Props = {
  buildTypeId: BuildTypeId
}

function BuildTypePauseDropdown(props: Props) {
  return (
    <Dropdown
      className={styles.dropwdown}
      hoverMode
      anchor={({active}) => (
        <IconButton
          icon="paused-12px"
          iconClassName={active ? styles.dropwdownActive : undefined}
          title=""
        >
          <span className={active ? styles.dropwdownActive : undefined}>
            {'Paused'}
            <SvgIcon icon="chevron-10px" className={styles.chevron} />
          </span>
        </IconButton>
      )}
    >
      <Popup>
        <BuildTypePauseInfo
          {...props}
          withIcon={false}
          className={styles.popup}
          lineBreakBeforeButton
        />
      </Popup>
    </Dropdown>
  )
}
export default BuildTypePauseDropdown
